export function compareActionText(
  isAdding: boolean,
  isAdded: boolean,
  labels: { adding: string; added: string; idle: string }
): string {
  if (isAdding) return labels.adding;
  if (isAdded) return labels.added;
  return labels.idle;
}

export const CARD_COMPARE_LABELS = {
  adding: 'Adding…',
  added: 'Added',
  idle: 'Compare'
} as const;

export const PANEL_COMPARE_LABELS = {
  adding: 'Adding…',
  added: 'Added to Comparison',
  idle: 'Add to Comparison'
} as const;

export type CompareActionLabels = {
  adding: string;
  added: string;
  idle: string;
};

export function pairSelectLabels(pairName: string): CompareActionLabels {
  return {
    adding: 'Adding…',
    added: `Selected for ${pairName}`,
    idle: `Select for ${pairName}`
  };
}
